export default __webpack_public_path__ + "static/media/program_intro_6.632e23b5.png";